import Parse from "../../../api/ApiConfig";

export const singularize = (word) => {
	const endings = {
		ves: "fe",
		ies: "y",
		i: "us",
		zes: "ze",
		ses: "s",
		es: "e",
		s: "",
	};
	return word.replace(
		new RegExp(`(${Object.keys(endings).join("|")})$`),
		(r) => endings[r]
	);
};

export const Capitalize = (word) => {
	return word[0].toUpperCase() + word.substring(1).toLowerCase();
};

 export const formatTextField = (data)=>{
  const points = data.split("\n");
// Remove empty points and add a semicolon at the end of each point
const formattedPoints = points
  .filter((point) => point.trim() !== "")
  .map((point) => point.trim() + ";");
// Send the formatted points to the backend server (you can implement this part)
 return formattedPoints.join("");
}

export const fetchAllCategories = async () => {
	const Category = Parse.Object.extend("Category");
	const query = new Parse.Query(Category);

	try {
		const category = await query.find();
		if (!category) {
			// toast.error("No category found!");
			return;
		} else {
			const categories = category.map((category) =>
				category.get("categoryName")
			);
			const allCategories = [...new Set(categories)];
			return allCategories;
		}
	} catch (error) {
		return error;
	}
};

export const fetchSubCategories = async (category) => {
	const Category = Parse.Object.extend("Category");
	const query = new Parse.Query(Category);
	query.equalTo("categoryName", category);
	try {
		const category = await query.find();
		if (!category) {
			return [];
		} else {
			const subCategories = category.map((cat) => {
				return {
					name: cat.get("subCategory"),
					id: cat.id,
				};
			});
			return subCategories;
		}
	} catch (error) {
		return error;
	}
};

export const fetchBrands = async (id) => {
	const Brand = Parse.Object.extend("Brand");
	const query = new Parse.Query(Brand);
	query.equalTo("categoryId", id);

	try {
		const category = await query.find();
		if (!category || category.length === 0) {
			return [];
		}

		const brands = category.map((cat) => ({
			name: cat.get("brand"),
			categoryId: cat.get("categoryId"),
		}));
		const uniqueBrands = [...new Set(brands.map((brand) => brand.name))];
		const allBrands = uniqueBrands.map((brand) => {
			const brandObj = brands.find((b) => b.name === brand);
			return { name: brand, catId: brandObj.categoryId };
		});

		return allBrands;
	} catch (error) {
		return error;
	}
};

export const fetchModels = async (name, catId) => {
	// Get a list of all models of a brand in a specific sub-category
	const Brand = Parse.Object.extend("Brand");
	const query = new Parse.Query(Brand);
	query.equalTo("categoryId", catId); // Id of the category/sub-category
	query.equalTo("brand", name);

	try {
		const brand = await query.find();
		if (!brand) {
			return [];
		}
		const models = brand.map((brand) => {
			brand.get("model");
			return {
				name: brand.get("model"),
			};
		});
		return models;
	} catch (error) {
		return error;
	}
};

export const editBrandName = async (id, prevName, NewName) => {
	const Brand = Parse.Object.extend("Brand");
	const query = new Parse.Query(Brand);
	query.equalTo("categoryId", id);
	query.equalTo("brand", prevName);
	try {
		const brands = await query.find();
		for (const brand of brands) {
			brand.set("brand", NewName);
			await brand.save();
		}
		return brands;
	} catch (error) {
		return error;
	}
};

export const editModelName = async (
	subCatId,
	brandName,
	prevModelName,
	newModelName
) => {
	const Brand = Parse.Object.extend("Brand");
	const query = new Parse.Query(Brand);
	query.equalTo("categoryId", subCatId);
	query.equalTo("brand", brandName);
	query.equalTo("model", prevModelName);
	try {
		const brands = await query.find();

		for (const brand of brands) {
			brand.set("model", newModelName);
			await brand.save();
		}
		return brands;
	} catch (error) {
		return error;
	}
};

export const deleteCategory = async (category) => {
	let categoryDetails = { categoryName: category };

	try {
		const response = await fetch(
			`${Parse.serverURL}/functions/deleteCategory`,
			{
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(categoryDetails),
			}
		);
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const deleteSubcategory = async (subcategoryId) => {
	let subcategoryDetails = { objectId: subcategoryId };

	try {
		const response = await fetch(
			`${Parse.serverURL}/functions/deleteSubCategory`,
			{
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(subcategoryDetails),
			}
		);
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const deleteBrand = async (catId, brandName) => {
	let brandDetails = { categoryId: catId, brand: brandName };

	try {
		const response = await fetch(`${Parse.serverURL}/functions/deleteBrand`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			body: JSON.stringify(brandDetails),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const deleteModel = async (modelId) => {
	let modelDetails = { objectId: modelId };

	try {
		const response = await fetch(`${Parse.serverURL}/functions/deleteModel`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			body: JSON.stringify(modelDetails),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};
